import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=756f9edd&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=756f9edd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f9edd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756f9edd')) {
      api.createRecord('756f9edd', component.options)
    } else {
      api.reload('756f9edd', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=756f9edd&scoped=true&", function () {
      api.rerender('756f9edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26NSAI47OscGW/JS/comp/GuestBox.vue"
export default component.exports